module.exports = __webpack_public_path__ + "static/media/19.5b19379f.JPG";